"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9158],{

/***/ 54208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _components_icons_ThumbsUpIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76447);
/* harmony import */ var _components_icons_ColoredThumbsUpIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45936);




var ThumbsUpButton = function(param) {
    var onClick = param.onClick, upvoted = param.upvoted, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("button", {
        type: "button",
        onClick: onClick,
        css: {
            border: 0,
            background: "none",
            display: "inline-flex",
            padding: 0,
            outline: "none",
            cursor: disabled ? "normal" : "pointer",
            height: 18
        },
        children: upvoted ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_icons_ColoredThumbsUpIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_icons_ThumbsUpIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ThumbsUpButton);


/***/ }),

/***/ 7853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95576);
/* harmony import */ var _govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77876);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59496);
/* harmony import */ var _components_icons_AnonymousUser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71985);







var FeedAuthorPicture = function(param) {
    var _gatedAuthor = param.gatedAuthor, gatedAuthor = _gatedAuthor === void 0 ? false : _gatedAuthor, author = param.author, government = param.government, vendor = param.vendor, group = param.group, context = param.context;
    if (gatedAuthor && government) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/governments/[governmentSlug]/[[...content]]",
            as: "/governments/".concat(government.slug),
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                css: {
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
                    maxWidth: "230px",
                    textAlign: "center",
                    "aria-label": government.name,
                    label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("span", {
                        children: [
                            government.name,
                            " ",
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("br", {}),
                            " ",
                            government.city.countryName
                        ]
                    }),
                    bg: "blue.600",
                    py: 2,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                                size: 45,
                                image: government.logo,
                                name: government.name
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                position: "absolute",
                                bottom: 1,
                                right: -3,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .CountryFlag */ .AW, {
                                    countryCode: government.city.country,
                                    width: 24,
                                    height: 14
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
    if (gatedAuthor && vendor) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/vendors/[vendorSlug]",
            as: "/vendors/".concat(vendor.slug),
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                css: {
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
                    maxWidth: "230px",
                    textAlign: "center",
                    "aria-label": vendor.name,
                    label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                        children: vendor.name
                    }),
                    bg: "blue.600",
                    py: 2,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        position: "relative",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                            size: 45,
                            image: vendor.logo,
                            name: vendor.name
                        })
                    })
                })
            })
        });
    }
    if (author && author.slug) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
            css: {
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    passHref: true,
                    href: "/[userSlug]/[[...tab]]",
                    as: "/@".concat(author.slug),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                        css: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                            size: 45,
                            image: author.avatar,
                            name: author.fullName
                        })
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(EntityLogo, {
                    author: author,
                    context: context,
                    government: government,
                    group: group
                })
            ]
        });
    }
    if (author) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_icons_AnonymousUser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            height: 45,
            width: 45
        });
    }
    return null;
};
var EntityLogo = function(param) {
    var author = param.author, context = param.context, government = param.government, group = param.group;
    if (context === "group") {
        if (author.__typename === "GovernmentUser" && author.government) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GovernmentLogo, {
                government: author.government
            });
        }
        if (author.__typename === "VendorUser" && author.company) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CompanyLogo, {
                company: author.company
            });
        }
    }
    if (government) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GovernmentLogo, {
            government: government
        });
    }
    if (group) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GroupLogo, {
            group: group
        });
    }
    if (author.__typename === "GovernmentUser" && author.government) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GovernmentLogo, {
            government: author.government
        });
    }
    if (author.__typename === "VendorUser" && author.company) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CompanyLogo, {
            company: author.company
        });
    }
    return null;
};
var GovernmentLogo = function(param) {
    var government = param.government;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/governments/[governmentSlug]/[[...content]]",
        as: "/governments/".concat(government.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
            css: {
                position: "absolute",
                bottom: -8,
                right: -4
            },
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                size: 24,
                image: government.logo,
                name: government.name,
                css: {
                    borderColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .white */ .ix,
                    borderWidth: 2
                }
            })
        })
    });
};
var CompanyLogo = function(param) {
    var company = param.company;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/vendors/[vendorSlug]",
        as: "/vendors/".concat(company.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
            css: {
                position: "absolute",
                bottom: -8,
                right: -4
            },
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                size: 24,
                image: company.logo,
                name: company.name,
                css: {
                    borderColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .white */ .ix,
                    borderWidth: 2
                }
            })
        })
    });
};
var GroupLogo = function(param) {
    var group = param.group;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        passHref: true,
        href: "/groups/[groupSlug]",
        as: "/groups/".concat(group.slug),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
            css: {
                position: "absolute",
                bottom: -8,
                right: -4
            },
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                size: 24,
                image: group.logo,
                name: group.name,
                css: {
                    borderColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .white */ .ix,
                    borderWidth: 2
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeedAuthorPicture);


/***/ }),

/***/ 44087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Time; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95576);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _src_shared_components_IntlRelativeTime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89989);
/* harmony import */ var _components_mediaQueries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92418);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52126);









var FeedCardPitch = function(param) {
    var author = param.author, _gatedAuthor = param.gatedAuthor, gatedAuthor = _gatedAuthor === void 0 ? false : _gatedAuthor, government = param.government, vendor = param.vendor, action = param.action, target = param.target, targetLink = param.targetLink, date = param.date;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        css: (0,_components_mediaQueries__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .darkGray */ .O5,
            display: "flex",
            flexDirection: [
                "column",
                "row"
            ],
            fontSize: 15
        }),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(EntityName, {
                author: author,
                government: government,
                vendor: vendor,
                gatedAuthor: gatedAuthor
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_components_spacings__WEBPACK_IMPORTED_MODULE_4__/* .Margin */ .Zt, {
                mx: [
                    0,
                    5
                ],
                children: [
                    action,
                    " ",
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Target, {
                        target: target,
                        targetLink: targetLink
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Time, {
                date: date,
                targetLink: targetLink
            })
        ]
    });
};
var Time = function(param) {
    var date = param.date, targetLink = param.targetLink;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("span", {
        css: {
            display: "flex",
            alignItems: "center",
            fontSize: 13,
            color: "#adadad",
            letterSpacing: 0.5
        },
        children: [
            "•",
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_4__/* .Margin */ .Zt, {
                ml: 3,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, targetLink), {
                    passHref: true,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                        css: {
                            color: "#adadad",
                            ":hover": {
                                textDecoration: "underline !important"
                            }
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_shared_components_IntlRelativeTime__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            value: date
                        })
                    })
                }))
            })
        ]
    });
};
var Target = function(param) {
    var target = param.target, targetLink = param.targetLink;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, targetLink), {
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
            css: {
                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .darkGray */ .O5,
                fontWeight: 600,
                ":hover": {
                    textDecoration: "underline !important"
                }
            },
            children: target
        })
    }));
};
var EntityName = function(param) {
    var gatedAuthor = param.gatedAuthor, author = param.author, government = param.government, vendor = param.vendor;
    if (gatedAuthor && government) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "/government?governmentSlug=".concat(government.slug),
            as: "/government/".concat(government.slug),
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                css: {
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .primary */ .T$,
                    fontWeight: "bold",
                    ":hover": {
                        textDecoration: "underline !important"
                    }
                },
                children: government.name
            })
        });
    }
    if (gatedAuthor && vendor) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "/vendor?vendorSlug=".concat(vendor.slug),
            as: "/vendor/".concat(vendor.slug),
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                css: {
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .primary */ .T$,
                    fontWeight: "bold",
                    ":hover": {
                        textDecoration: "underline !important"
                    }
                },
                children: vendor.name
            })
        });
    }
    if (author && author.slug) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "/user?userSlug=".concat(author.slug),
            as: "/user/".concat(author.slug),
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                css: {
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .primary */ .T$,
                    fontWeight: "bold",
                    ":hover": {
                        textDecoration: "underline !important"
                    }
                },
                children: author.fullName
            })
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (FeedCardPitch);


/***/ }),

/***/ 71985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95576);





var AnonymousUser = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 53 53"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: "M18.613 41.552l-7.907 4.313a7.106 7.106 0 0 0-1.269.903A26.377 26.377 0 0 0 26.5 53c6.454 0 12.367-2.31 16.964-6.144a7.015 7.015 0 0 0-1.394-.934l-8.467-4.233a3.229 3.229 0 0 1-1.785-2.888v-3.322c.238-.271.51-.619.801-1.03a19.482 19.482 0 0 0 2.632-5.304c1.086-.335 1.886-1.338 1.886-2.53v-3.546c0-.78-.347-1.477-.886-1.965v-5.126s1.053-7.977-9.75-7.977-9.75 7.977-9.75 7.977v5.126a2.644 2.644 0 0 0-.886 1.965v3.546c0 .934.491 1.756 1.226 2.231.886 3.857 3.206 6.633 3.206 6.633v3.24a3.232 3.232 0 0 1-1.684 2.833z",
                fill: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .washGray */ .aF
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: "M26.953.004C12.32-.246.254 11.414.004 26.047-.138 34.344 3.56 41.801 9.448 46.76a7.041 7.041 0 0 1 1.257-.894l7.907-4.313a3.23 3.23 0 0 0 1.683-2.835v-3.24s-2.321-2.776-3.206-6.633a2.66 2.66 0 0 1-1.226-2.231v-3.546c0-.78.347-1.477.886-1.965v-5.126S15.696 8 26.499 8s9.75 7.977 9.75 7.977v5.126c.54.488.886 1.185.886 1.965v3.546c0 1.192-.8 2.195-1.886 2.53a19.482 19.482 0 0 1-2.632 5.304c-.291.411-.563.759-.801 1.03V38.8c0 1.223.691 2.342 1.785 2.888l8.467 4.233a7.05 7.05 0 0 1 1.39.932c5.71-4.762 9.399-11.882 9.536-19.9C53.246 12.32 41.587.254 26.953.004z",
                fill: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .sealBlue */ .N9
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AnonymousUser);


/***/ }),

/***/ 2409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





var BookmarkIcon = function(_param) /*#__PURE__*/ {
    var _fill = _param.fill, fill = _fill === void 0 ? "#FFF" : _fill, _stroke = _param.stroke, stroke = _stroke === void 0 ? "#A5ADBA" : _stroke, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "fill",
        "stroke"
    ]);
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 12 18",
        width: 12,
        height: 18
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            d: "M11.47 17.205l-5.345-5.452a.175.175 0 00-.25 0L.53 17.205V.54h10.942v16.665z",
            fillRule: "nonzero",
            fill: fill,
            stroke: stroke
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BookmarkIcon);


/***/ }),

/***/ 45936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var ColoredThumbsUpIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 18 19",
        width: 18,
        height: 19
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
            transform: "translate(.706 .36)",
            fillRule: "nonzero",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    stroke: "#0071BB",
                    fill: "#FFF",
                    d: "M.176 6.66h5.295v9H.176z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    d: "M15.176 11.34h-.352a.178.178 0 00-.177.18c0 .1.08.18.177.18a1.25 1.25 0 011.235 1.26 1.25 1.25 0 01-1.235 1.26h-.353a.178.178 0 00-.177.18c0 .1.08.18.177.18a1.25 1.25 0 011.235 1.26 1.25 1.25 0 01-1.235 1.26h-1.068c-.011 0-1.188.06-2.218.06-.598 0-1.027-.02-1.276-.058-.48-.074-1.113-.338-1.785-.618-.906-.377-1.84-.767-2.653-.818V6.66h1.94c.061 0 .118-.032.15-.084.076-.122 1.867-3.02 2.141-4.38.163-.81.628-2.016 1.24-2.016.372 0 .753.176.994.458.194.227.28.503.242.777-.057.418-.281 1.059-.498 1.678-.478 1.366-.747 2.226-.462 2.639a.491.491 0 00.43.208h3.881a1.25 1.25 0 011.236 1.26 1.25 1.25 0 01-1.236 1.26h-.353a.178.178 0 00-.176.18c0 .1.08.18.176.18a1.25 1.25 0 011.236 1.26 1.25 1.25 0 01-1.236 1.26z",
                    stroke: "#0071BB",
                    fill: "#0071BB"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                    fill: "#0071BB",
                    cx: 2.471,
                    cy: 12.96,
                    r: 1
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ColoredThumbsUpIcon);


/***/ }),

/***/ 12135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var EditIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 18,
        height: 18
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    d: "M16.594 11.294a.449.449 0 00-.448.45v3.995a1.347 1.347 0 01-1.343 1.35H2.239a1.348 1.348 0 01-1.343-1.35V4.013c0-.745.601-1.35 1.343-1.35h3.975a.449.449 0 00.448-.45c0-.249-.2-.45-.448-.45H2.24A2.247 2.247 0 000 4.013v11.726a2.247 2.247 0 002.239 2.25h12.564a2.247 2.247 0 002.238-2.25v-3.995c0-.249-.2-.45-.447-.45z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    d: "M16.864.605a2.008 2.008 0 00-2.85 0L6.026 8.633a.45.45 0 00-.115.198l-1.05 3.812a.451.451 0 00.114.438.448.448 0 00.437.116l3.792-1.056a.447.447 0 00.197-.116l7.988-8.028a2.034 2.034 0 000-2.864l-.525-.528zm-9.862 8.32l6.538-6.57 2.108 2.119-6.538 6.57-2.108-2.118zm-.421.85l1.684 1.693-2.33.649.646-2.342zM16.756 3.36l-.475.478-2.108-2.12.475-.477a1.115 1.115 0 011.583 0l.525.528a1.13 1.13 0 010 1.591z"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (EditIcon);


/***/ }),

/***/ 76447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





var ThumbsUpIcon = function(_param) /*#__PURE__*/ {
    var _stroke = _param.stroke, stroke = _stroke === void 0 ? "#A5ADBA" : _stroke, _fill = _param.fill, fill = _fill === void 0 ? "#FFF" : _fill, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "stroke",
        "fill"
    ]);
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 18 19",
        width: 18,
        height: 19
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("g", {
            transform: "translate(.706 .36)",
            fillRule: "nonzero",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                    stroke: stroke,
                    fill: fill,
                    d: "M.176 6.66h5.295v9H.176zM15.176 11.34h-.352a.178.178 0 00-.177.18c0 .1.08.18.177.18a1.25 1.25 0 011.235 1.26 1.25 1.25 0 01-1.235 1.26h-.353a.178.178 0 00-.177.18c0 .1.08.18.177.18a1.25 1.25 0 011.235 1.26 1.25 1.25 0 01-1.235 1.26h-1.068c-.011 0-1.188.06-2.218.06-.598 0-1.027-.02-1.276-.058-.48-.074-1.113-.338-1.785-.618-.906-.377-1.84-.767-2.653-.818V6.66h1.94c.061 0 .118-.032.15-.084.076-.122 1.867-3.02 2.141-4.38.163-.81.628-2.016 1.24-2.016.372 0 .753.176.994.458.194.227.28.503.242.777-.057.418-.281 1.059-.498 1.678-.478 1.366-.747 2.226-.462 2.639a.491.491 0 00.43.208h3.881a1.25 1.25 0 011.236 1.26 1.25 1.25 0 01-1.236 1.26h-.353a.178.178 0 00-.176.18c0 .1.08.18.176.18a1.25 1.25 0 011.236 1.26 1.25 1.25 0 01-1.236 1.26z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("circle", {
                    fill: stroke,
                    cx: 2.471,
                    cy: 12.96,
                    r: 1
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ThumbsUpIcon);


/***/ }),

/***/ 31186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DocumentCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _components_post_RemoveButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32788);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95576);
/* harmony import */ var _components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82543);







function getCardColor(mimeType) {
    if ((0,_components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_2__/* .isPdf */ .Ze)(mimeType)) {
        return {
            background: "#ffdfdf",
            borderColor: "#f6bdbd"
        };
    } else if ((0,_components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_2__/* .isSheet */ .bP)(mimeType)) {
        return {
            background: "#bde4c7",
            borderColor: "#91cda0"
        };
    } else {
        return {
            background: "#e3f3fb",
            borderColor: "#c1dae6"
        };
    }
}
function DocumentCard(param) {
    var url = param.url, filename = param.filename, mimeType = param.mimeType, sizeInBytes = param.sizeInBytes, _onRemove = param.onRemove, onRemove = _onRemove === void 0 ? null : _onRemove;
    var color = getCardColor(mimeType);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: {
            position: "relative",
            background: color.background,
            borderRadius: 4,
            border: "1px solid ".concat(color.borderColor)
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                href: url,
                target: "_blank",
                rel: "noreferrer noopener",
                css: {
                    padding: 8,
                    display: "block"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                    css: {
                        display: "flex"
                    },
                    children: [
                        (0,_components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_2__/* .isWord */ .I9)(mimeType) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                            css: {
                                boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.39)"
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Doc, {
                                width: 34,
                                height: 44
                            })
                        }),
                        (0,_components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_2__/* .isSheet */ .bP)(mimeType) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                            css: {
                                boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.39)"
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Xls, {
                                width: 34,
                                height: 44
                            })
                        }),
                        (0,_components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_2__/* .isPdf */ .Ze)(mimeType) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Pdf, {
                                width: 34,
                                height: 44
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                            css: {
                                marginLeft: 12,
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("p", {
                                    css: {
                                        margin: 0,
                                        fontSize: 15,
                                        fontWeight: "bold",
                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .darkGray */ .O5,
                                        wordBreak: "break-word"
                                    },
                                    children: filename
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("span", {
                                    css: {
                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .darkGray */ .O5,
                                        padding: "0 4px"
                                    },
                                    children: [
                                        " ",
                                        "•",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("p", {
                                    css: {
                                        margin: 0,
                                        fontSize: 12,
                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .darkGray */ .O5,
                                        wordBreak: "break-word"
                                    },
                                    children: [
                                        Math.round(sizeInBytes / 1024),
                                        "kb"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            onRemove && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_post_RemoveButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                onClick: function() {
                    return onRemove(url);
                },
                css: {
                    position: "absolute",
                    top: 10,
                    right: 10
                }
            })
        ]
    });
};
var Xls = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewBox: "0 0 56 56"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
                fill: "#e9e9e0"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                fill: "#d9d7ca",
                d: "M37.5.151V12h11.849z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
                fill: "#91cda0"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("g", {
                fill: "#fff",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                    d: "M20.379 48.105L22.936 53h-1.9l-1.6-3.801h-.137L17.576 53h-1.9l2.557-4.895-2.721-5.182h1.873l1.777 4.102h.137l1.928-4.102H23.1l-2.721 5.182zM27.037 42.924v8.832h4.635V53h-6.303V42.924h1.668zM39.041 50.238c0 .364-.075.718-.226 1.06s-.362.642-.635.902-.611.467-1.012.622a3.771 3.771 0 01-1.367.232c-.219 0-.444-.012-.677-.034s-.467-.062-.704-.116a3.686 3.686 0 01-.677-.226 2.17 2.17 0 01-.554-.349l.287-1.176c.127.073.289.144.485.212s.398.132.608.191c.209.06.419.107.629.144.209.036.405.055.588.055.556 0 .982-.13 1.278-.39.296-.26.444-.645.444-1.155 0-.31-.105-.574-.314-.793-.21-.219-.472-.417-.786-.595s-.654-.355-1.019-.533a6.173 6.173 0 01-1.025-.629 3.281 3.281 0 01-.793-.854c-.21-.328-.314-.738-.314-1.23 0-.446.082-.843.246-1.189s.385-.641.663-.882.602-.426.971-.554.759-.191 1.169-.191c.419 0 .843.039 1.271.116.428.077.774.203 1.039.376a13.31 13.31 0 01-.191.39l-.205.396c-.064.123-.119.226-.164.308a1.263 1.263 0 01-.082.137c-.055-.027-.116-.063-.185-.109s-.167-.091-.294-.137a2.097 2.097 0 00-.506-.096 4.781 4.781 0 00-.807.014c-.183.019-.355.07-.52.157s-.31.193-.438.321a1.464 1.464 0 00-.301.431 1.1 1.1 0 00-.109.458c0 .364.104.658.314.882.209.224.469.419.779.588.31.169.647.333 1.012.492.364.159.704.354 1.019.581s.576.513.786.854c.212.342.317.781.317 1.319z"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M23.5 16v-4h-12v22h33V16h-21zm-10-2h8v2h-8v-2zm0 4h8v2h-8v-2zm0 4h8v2h-8v-2zm0 4h8v2h-8v-2zm8 6h-8v-2h8v2zm21 0h-19v-2h19v2zm0-4h-19v-2h19v2zm0-4h-19v-2h19v2zm-19-4v-2h19v2h-19z",
                fill: "#c8bdb8"
            })
        ]
    }));
};
var Pdf = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewBox: "0 0 56 56"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
                fill: "#e9e9e0"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                fill: "#d9d7ca",
                d: "M37.5.151V12h11.849z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M19.514 33.324c-.348 0-.682-.113-.967-.326-1.041-.781-1.181-1.65-1.115-2.242.182-1.628 2.195-3.332 5.985-5.068 1.504-3.296 2.935-7.357 3.788-10.75-.998-2.172-1.968-4.99-1.261-6.643.248-.579.557-1.023 1.134-1.215a4.91 4.91 0 011.016-.172c.504 0 .947.649 1.261 1.049.295.376.964 1.173-.373 6.802 1.348 2.784 3.258 5.62 5.088 7.562 1.311-.237 2.439-.358 3.358-.358 1.566 0 2.515.365 2.902 1.117.32.622.189 1.349-.39 2.16-.557.779-1.325 1.191-2.22 1.191-1.216 0-2.632-.768-4.211-2.285-2.837.593-6.15 1.651-8.828 2.822-.836 1.774-1.637 3.203-2.383 4.251-1.025 1.435-1.909 2.105-2.784 2.105zm2.662-5.126c-2.137 1.201-3.008 2.188-3.071 2.744-.01.092-.037.334.431.692.149-.047 1.019-.444 2.64-3.436zm13.637-4.442c.815.627 1.014.944 1.547.944.234 0 .901-.01 1.21-.441.149-.209.207-.343.23-.415-.123-.065-.286-.197-1.175-.197-.505.001-1.14.023-1.812.109zm-7.47-6.582a71.291 71.291 0 01-2.674 7.564 49.966 49.966 0 016.496-2.02c-1.35-1.568-2.699-3.526-3.822-5.544zm-.607-8.462c-.098.033-1.33 1.757.096 3.216.949-2.115-.053-3.23-.096-3.216zM48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
                fill: "#cc4b4c"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("g", {
                fill: "#fff",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                    d: "M17.385 53h-1.641V42.924h2.898c.428 0 .852.068 1.271.205.419.137.795.342 1.128.615.333.273.602.604.807.991s.308.822.308 1.306c0 .511-.087.973-.26 1.388a2.9 2.9 0 01-.725 1.046c-.31.282-.684.501-1.121.656s-.921.232-1.449.232h-1.217V53zm0-8.832v3.992h1.504c.2 0 .398-.034.595-.103.196-.068.376-.18.54-.335.164-.155.296-.371.396-.649.1-.278.15-.622.15-1.032 0-.164-.023-.354-.068-.567a1.637 1.637 0 00-.28-.615 1.657 1.657 0 00-.595-.492c-.255-.132-.593-.198-1.012-.198h-1.23zM32.219 47.682c0 .829-.089 1.538-.267 2.126s-.403 1.08-.677 1.477-.581.709-.923.937-.672.398-.991.513a4.094 4.094 0 01-.875.219c-.264.03-.46.046-.588.046h-3.814V42.924h3.035c.848 0 1.593.135 2.235.403s1.176.627 1.6 1.073.74.955.95 1.524c.21.57.315 1.156.315 1.758zm-4.867 4.115c1.112 0 1.914-.355 2.406-1.066s.738-1.741.738-3.09c0-.419-.05-.834-.15-1.244-.101-.41-.294-.781-.581-1.114s-.677-.602-1.169-.807-1.13-.308-1.914-.308h-.957v7.629h1.627zM36.266 44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244h-4.634z"
                })
            })
        ]
    }));
};
var Doc = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewBox: "0 0 56 56"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
                fill: "#e9e9e0"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                fill: "#d9d7ca",
                d: "M37.5.151V12h11.849z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M18.5 13h-6a1 1 0 010-2h6a1 1 0 010 2zM21.5 18h-9a1 1 0 010-2h9a1 1 0 010 2zM25.5 18c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.37-.37 1.05-.37 1.42 0 .18.19.29.45.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29zM37.5 18h-8a1 1 0 010-2h8a1 1 0 010 2zM12.5 33c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.37-.37 1.05-.37 1.42 0 .18.19.29.44.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29zM24.5 33h-8a1 1 0 010-2h8a1 1 0 010 2zM43.5 18h-2a1 1 0 010-2h2a1 1 0 010 2zM34.5 23h-22a1 1 0 010-2h22a1 1 0 010 2zM43.5 23h-6a1 1 0 010-2h6a1 1 0 010 2zM16.5 28h-4a1 1 0 010-2h4a1 1 0 010 2zM30.5 28h-10a1 1 0 010-2h10a1 1 0 010 2zM43.5 28h-9a1 1 0 010-2h9a1 1 0 010 2z",
                fill: "#8697cb"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
                fill: "#0096e6"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("g", {
                fill: "#fff",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                    d: "M23.5 47.682c0 .829-.089 1.538-.267 2.126s-.403 1.08-.677 1.477-.581.709-.923.937-.672.398-.991.513a4.094 4.094 0 01-.875.219c-.264.03-.46.046-.587.046h-3.814V42.924H18.4c.848 0 1.593.135 2.235.403s1.176.627 1.6 1.073.74.955.95 1.524c.21.57.315 1.156.315 1.758zm-4.867 4.115c1.112 0 1.914-.355 2.406-1.066s.738-1.741.738-3.09c0-.419-.05-.834-.15-1.244-.101-.41-.294-.781-.581-1.114s-.677-.602-1.169-.807-1.13-.308-1.914-.308h-.957v7.629h1.627zM33.475 47.914c0 .848-.107 1.595-.321 2.242-.214.647-.511 1.185-.889 1.613-.378.429-.82.752-1.326.971s-1.06.328-1.661.328-1.155-.109-1.661-.328-.948-.542-1.326-.971c-.378-.429-.675-.966-.889-1.613-.214-.647-.321-1.395-.321-2.242s.107-1.593.321-2.235c.214-.643.51-1.178.889-1.606.378-.429.82-.754 1.326-.978s1.06-.335 1.661-.335 1.155.111 1.661.335.948.549 1.326.978c.378.429.674.964.889 1.606.213.642.321 1.387.321 2.235zm-4.239 3.815c.337 0 .658-.066.964-.198.305-.132.579-.349.82-.649.241-.301.431-.695.567-1.183s.209-1.082.219-1.784c-.009-.684-.08-1.265-.212-1.743-.132-.479-.314-.873-.547-1.183s-.497-.533-.793-.67a2.203 2.203 0 00-.937-.205c-.337 0-.659.063-.964.191a2.065 2.065 0 00-.82.649c-.242.306-.431.699-.567 1.183s-.21 1.075-.219 1.777c.009.684.08 1.267.212 1.75.132.483.314.877.547 1.183s.497.528.793.67c.297.141.609.212.937.212zM42.607 51.975a3.73 3.73 0 01-1.271.82 4.212 4.212 0 01-1.531.273c-.602 0-1.155-.109-1.661-.328s-.948-.542-1.326-.971c-.378-.429-.675-.966-.889-1.613-.214-.647-.321-1.395-.321-2.242s.107-1.593.321-2.235c.214-.643.51-1.178.889-1.606a3.78 3.78 0 011.333-.978 4.069 4.069 0 011.654-.335c.547 0 1.057.091 1.531.273.474.183.897.456 1.271.82l-1.135 1.012a2.072 2.072 0 00-1.627-.752c-.337 0-.659.063-.964.191a2.065 2.065 0 00-.82.649c-.242.306-.431.699-.567 1.183s-.21 1.075-.219 1.777c.009.684.08 1.267.212 1.75.132.483.314.877.547 1.183s.497.528.793.67c.296.142.608.212.937.212s.636-.06.923-.178.549-.31.786-.574l1.134.999z"
                })
            })
        ]
    }));
};


/***/ }),

/***/ 3361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LinkCard; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95576);
/* harmony import */ var _components_post_RemoveButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32788);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19026);





function LinkCard(param) {
    var url = param.url, title = param.title, favicon = param.favicon, description = param.description, siteName = param.siteName, _onRemove = param.onRemove, onRemove = _onRemove === void 0 ? null : _onRemove;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: {
            background: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .washGray */ .aF,
            borderRadius: 4,
            boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.17)",
            position: "relative"
        },
        children: [
            onRemove && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_post_RemoveButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                onClick: function() {
                    return onRemove(url);
                },
                css: {
                    position: "absolute",
                    top: 10,
                    right: 10
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_2__/* .Anchor */ .ee, {
                href: url,
                external: "outside-govlaunch",
                css: {
                    display: "block",
                    padding: 24
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                            css: {
                                display: "flex"
                            },
                            children: [
                                favicon && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("img", {
                                    src: (0,_govlaunch_web__WEBPACK_IMPORTED_MODULE_2__/* .getSecureContent */ .qc)(favicon, "outside-govlaunch"),
                                    width: 30,
                                    height: 30,
                                    css: {
                                        marginRight: 8
                                    }
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("p", {
                                            css: {
                                                margin: 0,
                                                fontWeight: 500,
                                                fontSize: 16,
                                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .text */ .fL,
                                                letterSpacing: 0.57
                                            },
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("p", {
                                            css: {
                                                margin: "0 0 0 0",
                                                fontSize: 12,
                                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .darkGray */ .O5
                                            },
                                            children: siteName
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "16px 0 0",
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .text */ .fL
                            },
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 82543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I9": function() { return /* binding */ isWord; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "Ze": function() { return /* binding */ isPdf; },
/* harmony export */   "bP": function() { return /* binding */ isSheet; }
/* harmony export */ });
var isWord = function(mimeType) {
    return [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ].includes(mimeType);
};
var isPdf = function(mimeType) {
    return "application/pdf" === mimeType;
};
var isSheet = function(mimeType) {
    return [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ].includes(mimeType);
};
var isImage = function(mimeType) {
    return [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif"
    ].includes(mimeType);
};


/***/ }),

/***/ 51875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PostDetails; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56262);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95576);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59496);
/* harmony import */ var react_images__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91386);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69057);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35150);
/* harmony import */ var _components_feed_card_FeedAuthorPicture__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7853);
/* harmony import */ var _components_feed_card_FeedCardPitch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44087);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52126);
/* harmony import */ var _components_post_DocumentCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31186);
/* harmony import */ var _components_post_LinkCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3361);
/* harmony import */ var _components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82543);















var EntityLink = function(param) {
    var author = param.author, government = param.government, group = param.group, context = param.context;
    if (context === "group") {
        if (author.__typename === "GovernmentUser" && author.government) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/governments/[governmentSlug]/[[...content]]",
                as: "/governments/".concat(author.government.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("a", {
                    css: {
                        fontSize: 14,
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .darkGray */ .O5,
                        fontWeight: "bold",
                        wordBreak: "break-word",
                        ":hover": {
                            textDecoration: "underline !important"
                        }
                    },
                    children: author.government.name
                })
            });
        }
        if (author.__typename === "VendorUser" && author.company) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/vendors/[vendorSlug]",
                as: "/vendors/".concat(author.company.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("a", {
                    css: {
                        fontSize: 14,
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .darkGray */ .O5,
                        fontWeight: "bold",
                        wordBreak: "break-word",
                        ":hover": {
                            textDecoration: "underline !important"
                        }
                    },
                    children: author.company.name
                })
            });
        }
        return null;
    }
    if (government) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/governments/[governmentSlug]/[[...content]]",
            as: "/governments/".concat(government.slug),
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("a", {
                css: {
                    fontSize: 14,
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .darkGray */ .O5,
                    fontWeight: "bold",
                    wordBreak: "break-word",
                    display: "flex",
                    alignItems: "center",
                    ":hover": {
                        textDecoration: "underline !important"
                    }
                },
                children: [
                    government.name,
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Tooltip */ .u, {
                        maxWidth: "230px",
                        textAlign: "center",
                        "aria-label": government.name,
                        label: government.city.countryName,
                        bg: "blue.600",
                        py: 2,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                            as: "span",
                            display: "inline-flex",
                            ml: 2,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .CountryFlag */ .AW, {
                                countryCode: government.city.country,
                                width: 25,
                                height: 14
                            })
                        })
                    })
                ]
            })
        });
    }
    if (group) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            passHref: true,
            href: "/groups/[groupSlug]",
            as: "/groups/".concat(group.slug),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("a", {
                css: {
                    fontSize: 14,
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .darkGray */ .O5,
                    fontWeight: "bold",
                    wordBreak: "break-word",
                    ":hover": {
                        textDecoration: "underline !important"
                    }
                },
                children: group.name
            })
        });
    }
    return null;
};
function PostDetails(param) {
    var post = param.post, context = param.context;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(false), 2), isLightboxOpen = ref[0], toggleLightbox = ref[1];
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(post.attachments.filter(function(param) {
        var mimeType = param.mimeType;
        return (0,_components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_14__/* .isImage */ .Or)(mimeType);
    }), 1), image = ref1[0];
    var author = post.author, government = post.government, group = post.group;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_feed_card_FeedAuthorPicture__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        author: author,
                        context: context,
                        government: government,
                        group: group
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_components_spacings__WEBPACK_IMPORTED_MODULE_6__/* .Margin */ .Zt, {
                        ml: 10,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_feed_card_FeedCardPitch__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                author: author,
                                government: government,
                                action: intl.formatMessage({
                                    id: "uxICV0",
                                    defaultMessage: "shared a"
                                }),
                                target: intl.formatMessage({
                                    defaultMessage: "post",
                                    id: "X6hX1L"
                                }),
                                targetLink: {
                                    href: "/post?postId=".concat(post._id),
                                    as: "/posts/".concat(post._id)
                                },
                                date: post.createdAt
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_6__/* .Margin */ .Zt, {
                                mt: 4,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(EntityLink, {
                                    author: author,
                                    government: government,
                                    group: group,
                                    context: context
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_6__/* .Margin */ .Zt, {
                mt: 12,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
                    css: {
                        display: "grid",
                        gridRowGap: 12
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("p", {
                            css: {
                                justifySelf: "flex-start",
                                fontSize: 15,
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .darkGray */ .O5,
                                wordBreak: "break-word"
                            },
                            children: post.body
                        }),
                        post.links.map(function(link, index) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_post_LinkCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                url: link.url || "",
                                description: link.description || "",
                                favicon: link.favicon,
                                title: link.title || "",
                                siteName: link.siteName || ""
                            }, link.url || index);
                        }),
                        image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
                                    css: {
                                        display: "flex"
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("img", {
                                        src: image.url,
                                        onClick: toggleLightbox,
                                        css: {
                                            cursor: "pointer",
                                            maxHeight: 250,
                                            maxWidth: "100%",
                                            objectFit: "contain",
                                            boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.39)"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_images__WEBPACK_IMPORTED_MODULE_3__/* .ModalGateway */ .KP, {
                                    children: isLightboxOpen ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_images__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u_, {
                                        onClose: toggleLightbox,
                                        closeOnBackdropClick: true,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_images__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                            views: [
                                                image
                                            ].map(function(image) {
                                                return {
                                                    source: image.url
                                                };
                                            }),
                                            currentIndex: 0
                                        })
                                    }) : null
                                })
                            ]
                        }),
                        post.attachments.filter(function(param) {
                            var mimeType = param.mimeType;
                            return !(0,_components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_14__/* .isImage */ .Or)(mimeType);
                        }).map(function(document) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_post_DocumentCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                filename: document.filename,
                                mimeType: document.mimeType,
                                url: document.url,
                                sizeInBytes: document.sizeInBytes
                            }, document.url);
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 94742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PostFormModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-textarea-autosize@8.3.4_skqlhrap4das3cz5b6iqdn2lqi/node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(69585);
// EXTERNAL MODULE: ./components/form/FieldValidationError.tsx
var FieldValidationError = __webpack_require__(80360);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
;// CONCATENATED MODULE: ./components/post/fields/BodyField.tsx












function BodyField() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: "body",
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_textarea_autosize_browser_esm/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                        "onFocus"
                    ], input)), {
                        minRows: 3,
                        placeholder: intl.formatMessage({
                            defaultMessage: "Add a description for your post",
                            id: "2aNxft"
                        }),
                        css: {
                            width: "100%",
                            padding: 10,
                            fontSize: 14,
                            border: "solid 1px ".concat(palette/* lightestGray */.v2),
                            borderRadius: 4,
                            outline: 0,
                            resize: "none",
                            "&:focus": {
                                border: "solid 1px ".concat(palette/* primary */.T$)
                            },
                            "&::placeholder": {
                                color: palette/* sealBlue */.N9,
                                userSelect: "none"
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                        meta: meta
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldCharacterCount, {
                                    maxLength: 280,
                                    description: input.value,
                                    css: {
                                        marginLeft: "auto"
                                    }
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
function FieldCharacterCount(_param) {
    var description = _param.description, maxLength = _param.maxLength, css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "description",
        "maxLength",
        "css"
    ]);
    if (description.length > maxLength) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            css: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, css), {
                color: palette/* red */.Q6,
                fontSize: 12,
                userSelect: "none"
            }),
            children: [
                description.length,
                "/",
                maxLength
            ]
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, css), {
            color: palette/* sealBlue */.N9,
            fontSize: 12,
            userSelect: "none"
        }),
        children: [
            description.length,
            "/",
            maxLength
        ]
    }));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./components/post/icons/LinksToolbarIcon.tsx
var LinksToolbarIcon = __webpack_require__(65153);
// EXTERNAL MODULE: ./components/post/icons/ImageToolbarIcon.tsx
var ImageToolbarIcon = __webpack_require__(53486);
// EXTERNAL MODULE: ./components/post/icons/DocumentToolbarIcon.tsx
var DocumentToolbarIcon = __webpack_require__(26094);
// EXTERNAL MODULE: ./components/post/fields/LinkField.tsx
var LinkField = __webpack_require__(21836);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./lib/mutations/PostToGovernment.ts
var PostToGovernment = __webpack_require__(81525);
// EXTERNAL MODULE: ./lib/mutations/PostToGroup.ts
var PostToGroup = __webpack_require__(31002);
// EXTERNAL MODULE: ./lib/mutations/EditPost.ts
var EditPost = __webpack_require__(97165);
// EXTERNAL MODULE: ./components/post/utils.ts
var utils = __webpack_require__(57276);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./lib/mutations/DeletePost.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeletePost($id: ObjectId!) {\n    deletePost(id: $id)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var DeletePost = ((0,lib/* gql */.Ps)(_templateObject()));

// EXTERNAL MODULE: ./components/mobile/index.tsx
var mobile = __webpack_require__(31772);
// EXTERNAL MODULE: ./components/post/LinkCard.tsx
var LinkCard = __webpack_require__(3361);
// EXTERNAL MODULE: ./components/post/RemoveButton.tsx
var RemoveButton = __webpack_require__(32788);
// EXTERNAL MODULE: ./components/post/DocumentCard.tsx
var DocumentCard = __webpack_require__(31186);
// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./lib/hooks/useIntlValidationMessages.ts
var useIntlValidationMessages = __webpack_require__(67308);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
;// CONCATENATED MODULE: ./components/post/PostFormModal.tsx
































var POST_INITIAL_STATE = {
    links: [],
    documents: [],
    images: [],
    audience: "public"
};
var noop = function() {};
function PostFormModal(param) {
    var isOpen = param.isOpen, onRequestClose = param.onRequestClose, _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? POST_INITIAL_STATE : _initialValues, group = param.group, government = param.government, _onDelete = param.onDelete, onDelete = _onDelete === void 0 ? noop : _onDelete;
    var router = (0,next_router.useRouter)();
    if (!initialValues._id && (!government && !group || government && group)) {
        throw new Error("Please specify either `government` or `group`");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostFormScreen, {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
            mutation: PostToGovernment/* default */.Z,
            children: function(postToGovernment) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                    mutation: PostToGroup/* default */.Z,
                    children: function(postToGroup) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                            mutation: EditPost/* default */.Z,
                            children: function(editPost) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                    css: {
                                                        fontWeight: 500,
                                                        fontSize: 17,
                                                        color: palette/* darkGray */.O5,
                                                        margin: "0 0 4px 0"
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "What do you want to talk about?",
                                                        id: "FK8v6/"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostFormSubtitle, {
                                                    government: government,
                                                    group: group,
                                                    initialValues: initialValues
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostForm, {
                                            onDelete: onDelete,
                                            onRequestClose: onRequestClose,
                                            initialValues: initialValues,
                                            government: government,
                                            onSubmit: function(values) {
                                                // if there's id, post is being edited
                                                if (initialValues._id) {
                                                    return editPost({
                                                        variables: {
                                                            id: initialValues._id,
                                                            post: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* convertValuesToVariables */.R)(values)), {
                                                                audience: values.group ? "community" : values.audience.toLowerCase()
                                                            })
                                                        }
                                                    }).then(function() {
                                                        return onRequestClose();
                                                    });
                                                }
                                                if (government) {
                                                    return postToGovernment({
                                                        variables: {
                                                            government: government._id,
                                                            post: (0,utils/* convertValuesToVariables */.R)(values)
                                                        }
                                                    }).then(function(param) {
                                                        var data = param.data;
                                                        router.push("/posts/[postId]", "/posts/".concat(data.postToGovernment._id));
                                                    });
                                                } else if (group) {
                                                    return postToGroup({
                                                        variables: {
                                                            group: group._id,
                                                            post: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* convertValuesToVariables */.R)(values)), {
                                                                audience: "community"
                                                            })
                                                        }
                                                    }).then(function(param) {
                                                        var data = param.data;
                                                        router.push("/posts/[postId]", "/posts/".concat(data.postToGroup._id));
                                                    });
                                                }
                                            }
                                        })
                                    ]
                                });
                            }
                        });
                    }
                });
            }
        })
    });
};
function PostForm(param) {
    var onSubmit = param.onSubmit, initialValues = param.initialValues, onRequestClose = param.onRequestClose, onDelete = param.onDelete;
    var intl = (0,useIntl/* default */.Z)();
    var intlValidationMessages = (0,useIntlValidationMessages/* default */.Z)();
    var ref = (0,react.useState)(false), isAddingLink = ref[0], setIsAddingLink = ref[1];
    var validationSchema = es/* object */.Ry().shape({
        body: es/* string */.Z_().required(intlValidationMessages.cantBeBlank).min(3, intlValidationMessages.minCharacters(3)).max(280, intlValidationMessages.maxCharacters(280))
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
        onSubmit: onSubmit,
        initialValues: initialValues,
        validate: (0,validate/* default */.Z)(validationSchema),
        children: function(param) {
            var handleSubmit = param.handleSubmit, submitting = param.submitting, values = param.values, form = param.form;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 16,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodyField, {})
                    }),
                    values.images.map(function(image) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                marginTop: 12,
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: image.url,
                                    css: {
                                        maxHeight: 250,
                                        maxWidth: "100%",
                                        objectFit: "contain",
                                        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.39)"
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RemoveButton/* default */.Z, {
                                    onClick: function() {
                                        return form.change("images", []);
                                    },
                                    css: {
                                        position: "absolute",
                                        top: 10,
                                        left: 10
                                    }
                                })
                            ]
                        }, image.url);
                    }),
                    values.documents.map(function(document1) {
                        var filename = document1.filename, mimeType = document1.mimeType, sizeInBytes = document1.sizeInBytes, url = document1.url;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            mt: 12,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocumentCard/* default */.Z, {
                                url: url,
                                filename: filename,
                                mimeType: mimeType,
                                sizeInBytes: sizeInBytes,
                                onRemove: function() {
                                    return form.change("documents", []);
                                }
                            })
                        }, url);
                    }),
                    isAddingLink && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 12,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkField/* default */.Z, {
                            onCancel: function() {
                                return setIsAddingLink(false);
                            }
                        })
                    }),
                    values.links && Array.isArray(values.links) && values.links.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            marginTop: 15
                        },
                        children: values.links.map(function(_param) {
                            var url = _param.url, meta = (0,_object_without_properties/* default */.Z)(_param, [
                                "url"
                            ]);
                            if (!meta) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkCard/* default */.Z, {
                                    url: url || "",
                                    title: meta.title || "",
                                    siteName: meta.siteName || "",
                                    description: meta.description || "",
                                    favicon: meta.favicon || "",
                                    onRemove: function() {
                                        form.change("links", []);
                                    }
                                })
                            }, url || "");
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 16,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: values.links.length === 0 && values.images.length === 0 && values.documents.length === 0 && !isAddingLink && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "grid",
                                            gridTemplateColumns: "repeat(3, 1fr)",
                                            gridColumnGap: 12,
                                            maxWidth: 121
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarItem, {
                                                tooltip: intl.formatMessage({
                                                    defaultMessage: "Link",
                                                    id: "JBWS0c"
                                                }),
                                                onClick: function() {
                                                    return setIsAddingLink(true);
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinksToolbarIcon/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                name: "images",
                                                children: function(param) {
                                                    var input = param.input;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
                                                        options: {
                                                            accept: [
                                                                "image/jpeg",
                                                                "image/jpg",
                                                                "image/png",
                                                                "image/gif"
                                                            ]
                                                        },
                                                        onSuccess: function(param) {
                                                            var filesUploaded = param.filesUploaded;
                                                            if (filesUploaded.length > 0) {
                                                                var file = filesUploaded[0];
                                                                input.onChange([
                                                                    {
                                                                        filename: file.filename,
                                                                        mimeType: file.mimetype,
                                                                        sizeInBytes: file.size,
                                                                        url: file.url
                                                                    }, 
                                                                ]);
                                                                form.change("documents", []);
                                                                form.change("links", []);
                                                            }
                                                        },
                                                        customRender: function(param) {
                                                            var onPick = param.onPick;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarItem, {
                                                                tooltip: intl.formatMessage({
                                                                    defaultMessage: "Image",
                                                                    id: "+0zv6g"
                                                                }),
                                                                onClick: onPick,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageToolbarIcon/* default */.Z, {})
                                                            });
                                                        }
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                name: "documents",
                                                children: function(param) {
                                                    var input = param.input;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
                                                        options: {
                                                            accept: [
                                                                "application/msword",
                                                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                                "application/vnd.ms-excel",
                                                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                                                "application/pdf", 
                                                            ]
                                                        },
                                                        onSuccess: function(param) {
                                                            var filesUploaded = param.filesUploaded;
                                                            if (filesUploaded.length > 0) {
                                                                var file = filesUploaded[0];
                                                                input.onChange([
                                                                    {
                                                                        filename: file.filename,
                                                                        mimeType: file.mimetype,
                                                                        sizeInBytes: file.size,
                                                                        url: file.url
                                                                    }, 
                                                                ]);
                                                                form.change("links", []);
                                                                form.change("images", []);
                                                            }
                                                        },
                                                        customRender: function(param) {
                                                            var onPick = param.onPick;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarItem, {
                                                                tooltip: intl.formatMessage({
                                                                    defaultMessage: "Document",
                                                                    id: "wmirkP"
                                                                }),
                                                                onClick: onPick,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocumentToolbarIcon/* default */.Z, {})
                                                            });
                                                        }
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                        size: "xsmall",
                                        color: submitting ? "disabled" : palette/* innovatorBlue */.LD,
                                        disabled: submitting,
                                        type: "submit",
                                        css: {
                                            userSelect: "none"
                                        },
                                        children: submitting ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Saving",
                                            id: "QLkzoS"
                                        }) : initialValues._id ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Edit",
                                            id: "wEQDC6"
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Save",
                                            id: "jvo0vs"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    initialValues._id && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            borderTop: "1px solid ".concat(palette/* lightestGray */.v2),
                            paddingTop: 16,
                            marginTop: 16
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                            variables: {
                                id: initialValues._id
                            },
                            mutation: DeletePost,
                            children: function(deletePost, param) {
                                var loading = param.loading;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    onClick: function() {
                                        if (window.confirm(intl.formatMessage({
                                            defaultMessage: "Do you want to delete this post?",
                                            id: "ayJvhs"
                                        }))) {
                                            deletePost().then(function() {
                                                onRequestClose();
                                                onDelete();
                                            });
                                        }
                                    },
                                    role: "button",
                                    "aria-label": intl.formatMessage({
                                        defaultMessage: "Delete this post",
                                        id: "/Y4Y9C"
                                    }),
                                    css: {
                                        color: palette/* red */.Q6,
                                        fontSize: 14,
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        pointerEvents: loading ? "none" : "all",
                                        "&:hover": {
                                            opacity: 0.8
                                        }
                                    },
                                    children: loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Please wait...",
                                        id: "172N3w"
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Delete this post",
                                        id: "/Y4Y9C"
                                    })
                                });
                            }
                        })
                    })
                ]
            });
        }
    });
}
var ToolbarItem = function(_param) {
    var _active = _param.active, active = _active === void 0 ? false : _active, tooltip = _param.tooltip, props = (0,_object_without_properties/* default */.Z)(_param, [
        "active",
        "tooltip"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                isOpen: hovered,
                placement: "top",
                backgroundColor: palette/* innovatorBlue */.LD,
                render: function() {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            padding: 8,
                            color: palette/* white */.ix,
                            fontSize: 12,
                            fontWeight: "bold"
                        },
                        children: tooltip
                    });
                },
                borderColor: "transparent",
                boxStyle: {
                    boxShadow: "0 2px 12px 0 rgba(0, 0, 0, 0.2)",
                    zIndex: 9999
                },
                children: function(param) {
                    var innerRef = param.innerRef;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props, bind), {
                        ref: innerRef,
                        css: {
                            height: 35,
                            width: 35,
                            borderRadius: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: active ? "#b9e2fd" : palette/* lightestBlue */.I,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: active ? "#b9e2fd" : palette/* lightBlue */.f7
                            }
                        }
                    }));
                }
            });
        }
    });
};
var PostFormScreen = function(param) {
    var children = param.children, isOpen = param.isOpen, onRequestClose = param.onRequestClose;
    var isMobile = (0,useIsMobile/* default */.Z)();
    if (isMobile && isOpen) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreen */.vp, {
            isOpen: isOpen,
            children: function() {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreenHeader */.uD, {
                            onRequestClose: onRequestClose,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "New Post",
                                id: "BpOiBa"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreenBody */.Ly, {
                            children: children
                        })
                    ]
                });
            }
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Modal */.u_, {
        isOpen: isOpen,
        style: {
            overflow: "visible"
        },
        onRequestClose: function() {
            return onRequestClose();
        },
        appElement:  true ? document.body : 0,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                role: "button",
                css: {
                    color: palette/* darkGray */.O5,
                    fontSize: 24,
                    fontWeight: 500,
                    position: "absolute",
                    top: 12,
                    right: 12,
                    width: 12,
                    height: 12,
                    cursor: "pointer"
                },
                onClick: function() {
                    return onRequestClose();
                },
                children: "\xd7"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    width: isMobile ? 350 : 555,
                    padding: 16
                },
                children: children
            })
        ]
    });
};
var PostFormSubtitle = function(param) {
    var government = param.government, group = param.group, initialValues = param.initialValues;
    var intl = (0,useIntl/* default */.Z)();
    var paragraphCSS = {
        margin: 0,
        fontSize: 12,
        color: palette/* darkGray */.O5
    };
    if (government) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: paragraphCSS,
            children: intl.formatMessage({
                defaultMessage: "You're posting on behalf of <strong>{entityName}</strong>",
                id: "mL4Xcv"
            }, {
                entityName: government.name,
                // eslint-disable-next-line react/display-name
                strong: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontWeight: 600
                        },
                        children: text
                    });
                }
            })
        });
    }
    if (initialValues && initialValues.government) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: paragraphCSS,
            children: intl.formatMessage({
                defaultMessage: "You're posting on behalf of <strong>{entityName}</strong>",
                id: "mL4Xcv"
            }, {
                entityName: initialValues.government.name,
                // eslint-disable-next-line react/display-name
                strong: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontWeight: 600
                        },
                        children: text
                    });
                }
            })
        });
    }
    if (group) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: paragraphCSS,
            children: intl.formatMessage({
                defaultMessage: "This is a private post and will only be visible to members of {groupName}",
                id: "gMZeZf"
            }, {
                entityName: group.name,
                // eslint-disable-next-line react/display-name
                strong: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontWeight: 600
                        },
                        children: text
                    });
                }
            })
        });
    }
    if (initialValues && initialValues.group) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: paragraphCSS,
            children: intl.formatMessage({
                defaultMessage: "This is a private post and will only be visible to members of {groupName}",
                id: "gMZeZf"
            }, {
                entityName: initialValues.group.name,
                // eslint-disable-next-line react/display-name
                strong: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontWeight: 600
                        },
                        children: text
                    });
                }
            })
        });
    }
    return null;
};


/***/ }),

/***/ 32788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoveButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




function RemoveButton(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        type: "button",
        css: {
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 5,
            outline: 0,
            border: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            borderRadius: 2
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", {
            width: 10,
            height: 10,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                fill: "#FFF",
                d: "M9.4 1.48L8.52.6 5 4.12 1.48.6l-.88.88L4.12 5 .6 8.52l.88.88L5 5.88 8.52 9.4l.88-.88L5.88 5z"
            })
        })
    }));
};


/***/ }),

/***/ 21836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LinkField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94614);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56262);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56225);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98973);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95576);
/* harmony import */ var _lib_hooks_useUnfurl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82757);
/* harmony import */ var _components_post_LinkCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3361);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69057);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90489);










function LinkField(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onCancel = param.onCancel;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
        name: "links",
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                children: [
                    input.value.length === 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NewsworthyInput, {
                                    disabled: disabled,
                                    placeholder: intl.formatMessage({
                                        defaultMessage: "Paste a link and press Enter",
                                        id: "YdtjF2"
                                    }),
                                    onChange: function(item) {
                                        input.onChange([
                                            item
                                        ].concat(input.value));
                                        onCancel();
                                    }
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                                    role: "button",
                                    onClick: onCancel,
                                    css: {
                                        marginLeft: 16,
                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkGray */ .O5,
                                        fontWeight: 600,
                                        fontSize: 12,
                                        textAlign: "center",
                                        textTransform: "uppercase",
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        defaultMessage: "Cancel",
                                        id: "47FYwb"
                                    })
                                })
                            ]
                        })
                    }),
                    input.value && Array.isArray(input.value) && input.value.length > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                        css: {
                            marginTop: 15
                        },
                        children: input.value.map(function(_param) {
                            var url = _param.url, meta = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
                                "url"
                            ]);
                            if (!meta) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_post_LinkCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    url: url || "",
                                    title: meta.title || "",
                                    siteName: meta.siteName || "",
                                    description: meta.description || "",
                                    favicon: meta.favicon || "",
                                    onRemove: function() {
                                        input.onChange(input.value.filter(function(param) {
                                            var maybe = param.url;
                                            return url !== maybe;
                                        }));
                                    }
                                })
                            }, url || "");
                        })
                    })
                ]
            });
        }
    });
};
var NewsworthyInput = function(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, placeholder = param.placeholder, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), url = ref[0], setUrl = ref[1];
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_lib_hooks_useUnfurl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(url, function(unfurl) {
        inputRef.current.value = "";
        onChange(unfurl);
    }, function() {
        inputRef.current.value = "";
    }), 1), loading = ref1[0];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
        css: {
            position: "relative",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .II, {
                innerRef: inputRef,
                disabled: loading || disabled,
                autoFocus: true,
                onKeyDown: function(event) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        event.stopPropagation();
                        setUrl(event.target.value);
                    }
                },
                placeholder: placeholder,
                size: "small",
                css: {
                    paddingRight: loading ? 40 : 20
                }
            }),
            loading && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                css: {
                    position: "absolute",
                    top: "50%",
                    right: 20,
                    transform: "translateY(-50%)"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_2__/* .LoadingIndicator */ .TF, {})
            })
        ]
    });
};


/***/ }),

/***/ 26094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var DocumentToolbarIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 23,
        height: 20
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
            fill: "none",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#BCA98A",
                    d: "M17.565 1H5.435C4.642 1 4 1.62 4 2.386V9h15V2.386C19 1.621 18.358 1 17.565 1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E0CFAF",
                    d: "M18.373 2H4.626C3.728 2 3 2.776 3 3.733V12h17V3.733C20 2.776 19.272 2 18.373 2z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#FFF5D7",
                    d: "M19.182 6H3.818C2.814 6 2 6.776 2 7.733V16h19V7.733C21 6.776 20.186 6 19.182 6z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#BA7E56",
                    d: "M23 12.592v5.816c0 .88-.662 1.592-1.48 1.592H2.48C1.662 20 1 19.287 1 18.408v-5.816C1 11.712 1.662 11 2.479 11h3.005c.479 0 .898.346 1.023.843l.43 1.714c.126.498.545.843 1.024.843h8.078c.479 0 .898-.345 1.023-.843l.431-1.714c.125-.497.544-.843 1.023-.843h3.005c.817 0 1.479.713 1.479 1.592z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#000",
                    d: "M22.658 16.875a.342.342 0 00.342-.343v-3.888a1.85 1.85 0 00-1.5-1.818V7.36c0-.875-.507-1.633-1.24-1.995V4.35c0-.828-.508-1.538-1.226-1.835v-.767c0-.964-.781-1.748-1.74-1.748H5.47c-.96 0-1.74.784-1.74 1.748v.767A1.986 1.986 0 002.505 4.35v1.015a2.225 2.225 0 00-1.24 1.995v3.527A1.852 1.852 0 000 12.644v5.506C0 19.17.826 20 1.842 20h19.316C22.174 20 23 19.17 23 18.15v-.246a.342.342 0 10-.683 0v.246c0 .642-.52 1.164-1.16 1.164H1.843a1.162 1.162 0 01-1.16-1.164v-5.506c0-.642.52-1.164 1.159-1.164H4.89c.33 0 .622.224.708.544l.437 1.623A1.42 1.42 0 007.403 14.7h8.195c.638 0 1.2-.432 1.367-1.052l.437-1.623a.735.735 0 01.708-.544h3.048c.639 0 1.159.522 1.159 1.164v3.888c0 .19.153.343.341.343zM3.188 4.35c0-.716.58-1.298 1.292-1.298h1.366a.342.342 0 00.342-.343.342.342 0 00-.342-.343H4.48l-.066.002v-.62A1.06 1.06 0 015.471.686h11.822a1.06 1.06 0 011.057 1.062v.62l-.065-.002H7.213a.342.342 0 000 .686h11.072c.712 0 1.291.582 1.291 1.298v.807a2.208 2.208 0 00-.289-.02H3.477a2.3 2.3 0 00-.289.02V4.35zm13.554 7.495l-.437 1.623a.735.735 0 01-.708.545H7.403a.735.735 0 01-.708-.545l-.437-1.623a1.42 1.42 0 00-1.368-1.051H1.948V7.36c0-.847.686-1.536 1.53-1.536h15.81c.842 0 1.528.689 1.528 1.536v3.434H18.11c-.639 0-1.2.432-1.368 1.051z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#000",
                    d: "M10.665 8h-6.33C4.15 8 4 8.224 4 8.5s.15.5.335.5h6.33c.185 0 .335-.224.335-.5s-.15-.5-.335-.5zM7.72 9H4.28c-.154 0-.28.224-.28.5s.126.5.28.5h3.44c.154 0 .28-.224.28-.5S7.874 9 7.72 9z"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DocumentToolbarIcon);


/***/ }),

/***/ 53486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var ImageToolbarIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 22,
        height: 18
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
            fill: "none",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#F25A78",
                    d: "M1.1 6.6H22v6.6H1.1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    d: "M1.1 13.2v2.475c0 .456.38.825.85.825h19.2c.47 0 .85-.37.85-.825V13.2H1.1zm20.05-9.9h-4.927L14.758.456a.853.853 0 00-.76-.456H9.102a.853.853 0 00-.76.456L6.878 3.3h-1.53v-.825a.837.837 0 00-.85-.825h-.85a.838.838 0 00-.849.825V3.3h-.85a.838.838 0 00-.849.825V6.6H22V4.125a.837.837 0 00-.85-.825z",
                    fill: "#CEF"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#57555C",
                    d: "M16.5 10.45a4.95 4.95 0 11-9.902-.002 4.95 4.95 0 019.902.002z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#FFF",
                    d: "M11 6.6c1.82 0 3.3 1.48 3.3 3.3 0 1.82-1.48 3.3-3.3 3.3-1.82 0-3.3-1.48-3.3-3.3 0-1.82 1.48-3.3 3.3-3.3z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#000",
                    d: "M17.05 6.6a.55.55 0 100-1.1.55.55 0 000 1.1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#000",
                    d: "M20.71 3.352h-4.718L14.63.695A1.286 1.286 0 0013.477 0H8.523C8.032 0 7.59.266 7.37.695L6.008 3.352h-.852v-.419c0-.693-.578-1.257-1.289-1.257h-.86c-.71 0-1.288.564-1.288 1.257v.42h-.43C.58 3.352 0 3.915 0 4.61v11.733c0 .693.578 1.257 1.29 1.257h19.42c.712 0 1.29-.564 1.29-1.257V4.61c0-.694-.578-1.258-1.29-1.258zM.86 7.54h5.433a5.338 5.338 0 000 5.87H.859V7.54zm5.413 2.937c0-2.565 2.14-4.61 4.727-4.61 2.584 0 4.727 2.042 4.727 4.61 0 2.565-2.14 4.61-4.727 4.61-2.59 0-4.727-2.047-4.727-4.61zm10.313 0a5.338 5.338 0 00-.879-2.933h5.434v5.867h-5.434a5.34 5.34 0 00.879-2.934zM8.139 1.07a.429.429 0 01.384-.232h4.954c.164 0 .31.089.384.232l1.17 2.282H6.97L8.14 1.07zm-5.56 1.863c0-.23.192-.419.429-.419h.86c.236 0 .429.188.429.42v.418H2.578v-.419zM1.288 4.19H20.71c.237 0 .43.188.43.42v2.095h-6.112A5.659 5.659 0 0011 5.029c-1.522 0-2.98.609-4.03 1.676H.86V4.61c0-.232.192-.42.43-.42zM20.71 16.762H1.289a.425.425 0 01-.43-.42v-2.094h6.112A5.66 5.66 0 0011 15.924c1.522 0 2.98-.61 4.03-1.676h6.11v2.095a.425.425 0 01-.43.419z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#000",
                    d: "M12.787 2.2h-2.475c-.227 0-.412.246-.412.55 0 .304.185.55.412.55h2.476c.227 0 .412-.246.412-.55 0-.304-.185-.55-.412-.55zM11.55 14.3a3.854 3.854 0 003.85-3.85 3.854 3.854 0 00-3.85-3.85 3.854 3.854 0 00-3.85 3.85 3.854 3.854 0 003.85 3.85zm0-6.844a2.998 2.998 0 012.994 2.994 2.998 2.998 0 01-2.994 2.994 2.998 2.998 0 01-2.994-2.994 2.998 2.998 0 012.994-2.994z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#000",
                    d: "M9.167 11a.367.367 0 00.366-.367c0-.606.494-1.1 1.1-1.1a.367.367 0 000-.733c-1.01 0-1.833.822-1.833 1.833 0 .203.164.367.367.367zM19.25 6.6h1.1a.55.55 0 000-1.1h-1.1a.55.55 0 000 1.1z"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageToolbarIcon);


/***/ }),

/***/ 65153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LinksToolbarIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);


function LinksToolbarIcon() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("svg", {
        viewBox: "0 0 503.118 503.118",
        width: 20,
        height: 20,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: "M335.151 167.967c10.449 10.449 18.808 22.988 25.078 35.527 22.988 48.065 15.673 108.669-25.078 148.375L223.347 464.718c-51.2 51.2-133.747 51.2-183.902 0-51.2-51.2-51.2-133.747 0-183.902l79.412-79.412c-9.404 31.347-8.359 64.784 3.135 95.086l-33.437 33.437c-22.988 22.988-22.988 61.649 0 85.682 24.033 24.033 61.649 24.033 85.682 0l111.804-111.804c11.494-11.494 17.763-27.167 17.763-42.841s-6.269-31.347-17.763-42.841c-11.494-11.494-27.167-17.763-42.841-17.763l56.424-56.424c12.539 5.223 24.033 13.582 35.527 24.031z",
                fill: "#ffd15c"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: "M167.967 335.151c-10.449-10.449-18.808-22.988-25.078-35.527-22.988-48.065-15.673-108.669 25.078-148.376L279.771 38.4c51.2-51.2 133.747-51.2 183.902 0 51.2 51.2 51.2 133.747 0 183.902l-79.412 79.412c9.404-31.347 8.359-64.784-3.135-95.086l33.437-33.437c22.988-22.988 22.988-61.649 0-85.682-24.033-24.033-61.649-24.033-85.682 0l-110.759 112.85c-11.494 11.494-17.763 27.167-17.763 42.841s6.269 31.347 17.763 42.841c11.494 11.494 27.167 17.763 42.841 17.763l-56.424 56.424c-13.584-6.269-25.078-14.628-36.572-25.077z",
                fill: "#ff7058"
            })
        ]
    });
};


/***/ }),

/***/ 57276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertValuesToVariables; },
/* harmony export */   "V": function() { return /* binding */ convertPostToInitialValues; }
/* harmony export */ });
/* harmony import */ var lodash_fp_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53104);
/* harmony import */ var lodash_fp_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82543);


function convertPostToInitialValues(post) {
    var documents = post.attachments.filter(function(attachment) {
        return _components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_1__/* .isPdf */ .Ze(attachment.mimeType) || _components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_1__/* .isWord */ .I9(attachment.mimeType) || _components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_1__/* .isSheet */ .bP(attachment.mimeType);
    });
    var images = post.attachments.filter(function(attachment) {
        return _components_post_MimeTypes__WEBPACK_IMPORTED_MODULE_1__/* .isImage */ .Or(attachment.mimeType);
    });
    return {
        _id: post._id,
        body: post.body,
        documents: documents,
        images: images,
        links: post.links,
        type: documents.length > 0 ? "document" : images.length > 0 ? "image" : post.links.length > 0 ? "link" : null,
        audience: "community",
        government: post.government,
        group: post.group,
        vendor: post.vendor
    };
}
function convertValuesToVariables(values) {
    return {
        body: values.body,
        attachments: values.documents.concat(values.images).map(lodash_fp_omit__WEBPACK_IMPORTED_MODULE_0___default()([
            "__typename"
        ])),
        links: values.links.map(lodash_fp_omit__WEBPACK_IMPORTED_MODULE_0___default()([
            "__typename"
        ])),
        audience: "community"
    };
}


/***/ }),

/***/ 97165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_GovernmentPostFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26346);
/* harmony import */ var _lib_queries_fragments_VendorPostFields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50472);
/* harmony import */ var _lib_queries_fragments_GroupPostFields__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90910);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation EditPost($id: ObjectId!, $post: PostInput!) {\n    editPost(id: $id, post: $post) {\n      ... on GovernmentPost {\n        _id\n        ...GovernmentPostFields\n      }\n      ... on GroupPost {\n        _id\n        ...GroupPostFields\n      }\n      ... on VendorPost {\n        _id\n        ...VendorPostFields\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_VendorPostFields__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _lib_queries_fragments_GovernmentPostFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _lib_queries_fragments_GroupPostFields__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z));


/***/ }),

/***/ 81525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_GovernmentPostFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26346);
/* harmony import */ var _lib_queries_fragments_GroupPostFields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90910);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation PostToGovernment($government: ObjectId!, $post: PostInput!) {\n    postToGovernment(government: $government, post: $post) {\n      ... on GovernmentPost {\n        _id\n        ...GovernmentPostFields\n      }\n\n      ... on GroupPost {\n        _id\n        ...GroupPostFields\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_GovernmentPostFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _lib_queries_fragments_GroupPostFields__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z));


/***/ }),

/***/ 31002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_GovernmentPostFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26346);
/* harmony import */ var _lib_queries_fragments_GroupPostFields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90910);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation PostToGroup($group: ObjectId!, $post: PostInput!) {\n    postToGroup(group: $group, post: $post) {\n      ... on GovernmentPost {\n        _id\n        ...GovernmentPostFields\n      }\n\n      ... on GroupPost {\n        _id\n        ...GroupPostFields\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_GovernmentPostFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _lib_queries_fragments_GroupPostFields__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z));


/***/ }),

/***/ 96495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ToggleBookmark; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var _apollo_client_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82280);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _lib_mutations_ToggleBookmarkMutation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19805);




var getTypename = function(typename) {
    if (typename === "STORY") {
        return "Story";
    }
    if (typename === "PRODUCT") {
        return "Product";
    }
    if (typename === "POST") {
        return "Post";
    }
    return "Project";
};
function ToggleBookmark(param) {
    var targetId = param.targetId, targetType = param.targetType, viewerDidBookmark = param.viewerDidBookmark, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_apollo_client_react_components__WEBPACK_IMPORTED_MODULE_3__/* .Mutation */ .m, {
        mutation: _lib_mutations_ToggleBookmarkMutation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
        variables: {
            targetId: targetId,
            targetType: targetType
        },
        children: function(toggleBookmark) {
            return children({
                toggle: function() {
                    toggleBookmark({
                        optimisticResponse: {
                            __typename: "Mutation",
                            toggleBookmark: {
                                __typename: getTypename(targetType),
                                _id: targetId,
                                viewerDidBookmark: !viewerDidBookmark
                            }
                        }
                    });
                }
            });
        }
    });
};


/***/ }),

/***/ 97511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94614);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82789);
/* harmony import */ var _apollo_client_react_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82280);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _lib_queries_ProfileQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44982);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleUpvote($targetId: ObjectId!, $targetType: UpvoteTargetType!) {\n    toggleUpvote(targetId: $targetId, targetType: $targetType) {\n      ... on Product {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on Story {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on Project {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on Comment {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on Post {\n        ... on GovernmentPost {\n          _id\n          viewerDidUpvote\n          upvotesCount\n        }\n        ... on GroupPost {\n          _id\n          viewerDidUpvote\n          upvotesCount\n        }\n        ... on VendorPost {\n          _id\n          viewerDidUpvote\n          upvotesCount\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ToggleUpvote = function(_param) {
    var viewer = _param.viewer, upvotesCount = _param.upvotesCount, viewerDidUpvote = _param.viewerDidUpvote, targetId = _param.targetId, targetType = _param.targetType, entityType = _param.entityType, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "viewer",
        "upvotesCount",
        "viewerDidUpvote",
        "targetId",
        "targetType",
        "entityType",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_apollo_client_react_components__WEBPACK_IMPORTED_MODULE_5__/* .Mutation */ .m, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        mutation: ToggleUpvoteMutation,
        variables: {
            targetId: targetId,
            targetType: targetType
        }
    }, props), {
        children: function(toggleUpvote) {
            return children({
                toggle: function() {
                    toggleUpvote({
                        optimisticResponse: {
                            __typename: "Mutation",
                            toggleUpvote: {
                                __typename: guessTypename(targetType, entityType),
                                _id: targetId,
                                viewerDidUpvote: !viewerDidUpvote,
                                upvotesCount: upvotesCount + (viewerDidUpvote ? -1 : 1)
                            }
                        },
                        update: function(proxy) {
                            if (!viewer) {
                                return;
                            }
                            try {
                                var data = proxy.readQuery({
                                    query: _lib_queries_ProfileQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                                    variables: {
                                        slug: viewer.slug
                                    }
                                });
                                if (!data) {
                                    return;
                                }
                                var upvotesCount = data.user.upvotesCount;
                                proxy.writeQuery({
                                    query: _lib_queries_ProfileQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                                    variables: {
                                        slug: viewer.slug
                                    },
                                    data: {
                                        user: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data.user), {
                                            upvotesCount: upvotesCount + (viewerDidUpvote ? -1 : 1)
                                        })
                                    }
                                });
                            } catch (e) {} // eslint-disable-line
                        }
                    });
                }
            });
        }
    }));
};
var ToggleUpvoteMutation = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_templateObject());
function guessTypename(targetType, entityType) {
    if (targetType === "STORY") {
        return "Story";
    } else if (targetType === "PRODUCT") {
        return "Product";
    } else if (targetType === "PROJECT") {
        return "Project";
    } else if (targetType === "POST") {
        return "Post";
    } else if (entityType) {
        return entityType;
    }
    throw new Error("Invalid target type");
}
/* harmony default export */ __webpack_exports__["Z"] = (ToggleUpvote);


/***/ }),

/***/ 44982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProfileQuery; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
// EXTERNAL MODULE: ./lib/queries/fragments/GroupFields.ts
var GroupFields = __webpack_require__(89471);
;// CONCATENATED MODULE: ./lib/queries/fragments/FollowingFields.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FollowingFields on FollowTarget {\n    ... on PendingUser {\n      _id\n      slug\n      fullName\n      jobTitle\n      avatar\n    }\n    ... on GovernmentUser {\n      _id\n      slug\n      fullName\n      jobTitle\n      avatar\n      isInnovator\n    }\n    ... on VendorUser {\n      _id\n      slug\n      fullName\n      jobTitle\n      avatar\n      isDisruptor\n    }\n    ... on Government {\n      _id\n      slug\n      name\n      logo\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var FollowingFields = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./lib/queries/ProfileQuery.ts

function ProfileQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  query GetProfile($slug: String!) {\n    user(slug: $slug) {\n      ... on PendingUser {\n        _id\n        slug\n        firstName\n        lastName\n        fullName\n        email\n        notificationEmail\n        department {\n          _id\n          name\n        }\n        interests {\n          _id\n          name\n        }\n        cover {\n          original\n          repositioned\n        }\n        avatar\n        jobTitle\n        postsCount\n        upvotesCount\n        projectsCount\n        savedStoriesCount\n        savedProductsCount\n        savedProjectsCount\n        savedCount\n        savedPostsCount\n        storiesCount\n        projectsCount\n        isFollowing\n        linkedinUrl\n        isInnovator\n        isSelfie\n        isSiteAdmin\n        searchable\n        preferences {\n          showAsAuthorOnProjects\n        }\n        newsletterFrequency\n        subscribedToNewsletter\n        subscribedToCampaign\n        socialMedia {\n          youtube\n          twitter\n          instagram\n          linkedin\n          facebook\n        }\n        following {\n          ...FollowingFields\n        }\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n        country\n        language\n        timeZone\n      }\n      ... on GovernmentUser {\n        _id\n        slug\n        firstName\n        lastName\n        fullName\n        email\n        notificationEmail\n        department {\n          _id\n          name\n        }\n        interests {\n          _id\n          name\n        }\n        enabledSharing\n        avatar\n        jobTitle\n        upvotesCount\n        storiesCount\n        projectsCount\n        postsCount\n        savedStoriesCount\n        savedProductsCount\n        savedProjectsCount\n        savedPostsCount\n        savedCount\n        isFollowing\n        isInnovator\n        isSelfie\n        isSiteAdmin\n        searchable\n        preferences {\n          showAsAuthorOnProjects\n        }\n        newsletterFrequency\n        subscribedToNewsletter\n        subscribedToCampaign\n        socialMedia {\n          youtube\n          twitter\n          instagram\n          linkedin\n          facebook\n        }\n        linkedinUrl\n        sharing {\n          projects\n          stories\n          resources\n          posts\n        }\n        resources {\n          ... on LinkResource {\n            type\n            title\n            url\n            addedAt\n          }\n          ... on DownloadResource {\n            type\n            filename\n            title\n            url\n            addedAt\n          }\n          ... on TextResource {\n            type\n            title\n            body\n            addedAt\n          }\n        }\n        government {\n          _id\n          slug\n          logo\n          name\n          viewerIsMember\n          members {\n            _id\n            slug\n            avatar\n            firstName\n            fullName\n            jobTitle\n          }\n          city {\n            _id\n            name\n            country\n            countryName\n          }\n        }\n        cover {\n          original\n          repositioned\n        }\n        following {\n          ...FollowingFields\n        }\n        followers {\n          ... on PendingUser {\n            _id\n            slug\n            avatar\n            firstName\n            fullName\n            jobTitle\n            isFollowing\n          }\n          ... on VendorUser {\n            _id\n            slug\n            avatar\n            firstName\n            fullName\n            jobTitle\n            isFollowing\n            isDisruptor\n          }\n          ... on GovernmentUser {\n            _id\n            slug\n            avatar\n            firstName\n            fullName\n            jobTitle\n            isFollowing\n            isInnovator\n          }\n        }\n        posts {\n          ... on GroupPost {\n            _id\n            body\n            audience\n            viewerCanEdit\n            upvotesCount\n            commentsCount\n            viewerDidBookmark\n            viewerDidUpvote\n            viewerDidComment\n            createdAt\n            author {\n              ... on GovernmentUser {\n                _id\n                slug\n                firstName\n                fullName\n                avatar\n                jobTitle\n                email\n                government {\n                  _id\n                  slug\n                  name\n                  logo\n                }\n              }\n              ... on VendorUser {\n                _id\n                slug\n                firstName\n                fullName\n                avatar\n                jobTitle\n                email\n                company {\n                  _id\n                  slug\n                  name\n                  logo\n                }\n              }\n            }\n            group {\n              _id\n              slug\n              name\n            }\n            links {\n              url\n              description\n              favicon\n              title\n              siteName\n              addedAt\n            }\n            attachments {\n              mimeType\n              url\n              filename\n              sizeInBytes\n            }\n          }\n          ... on GovernmentPost {\n            _id\n            body\n            audience\n            viewerCanEdit\n            upvotesCount\n            commentsCount\n            viewerDidBookmark\n            viewerDidUpvote\n            viewerDidComment\n            createdAt\n            government {\n              _id\n              slug\n              name\n              logo\n              city {\n                _id\n                country\n                countryName\n              }\n            }\n            author {\n              __typename\n              ... on GovernmentUser {\n                _id\n                slug\n                firstName\n                fullName\n                avatar\n                jobTitle\n                email\n                government {\n                  _id\n                  slug\n                  name\n                  logo\n                }\n              }\n              ... on VendorUser {\n                _id\n                slug\n                firstName\n                fullName\n                avatar\n                jobTitle\n                email\n                company {\n                  _id\n                  slug\n                  name\n                }\n              }\n            }\n            links {\n              url\n              description\n              favicon\n              title\n              siteName\n              addedAt\n            }\n            attachments {\n              mimeType\n              url\n              filename\n              sizeInBytes\n            }\n          }\n\n          ... on VendorPost {\n            _id\n            body\n            audience\n            viewerCanEdit\n            upvotesCount\n            commentsCount\n            viewerDidBookmark\n            viewerDidUpvote\n            viewerDidComment\n            createdAt\n            vendor {\n              _id\n              slug\n              name\n              logo\n            }\n            author {\n              __typename\n              ... on GovernmentUser {\n                _id\n                slug\n                fullName\n                avatar\n                jobTitle\n                email\n                government {\n                  _id\n                  slug\n                  name\n                  logo\n                }\n              }\n              ... on VendorUser {\n                _id\n                slug\n                fullName\n                avatar\n                jobTitle\n                email\n                company {\n                  _id\n                  slug\n                  name\n                  logo\n                }\n              }\n            }\n            links {\n              url\n              description\n              favicon\n              title\n              siteName\n              addedAt\n            }\n            attachments {\n              mimeType\n              url\n              filename\n              sizeInBytes\n            }\n          }\n        }\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n        country\n        language\n        timeZone\n      }\n      ... on VendorUser {\n        _id\n        slug\n        firstName\n        lastName\n        email\n        notificationEmail\n        department {\n          _id\n          name\n        }\n        interests {\n          _id\n          name\n        }\n        fullName\n        postsCount\n        upvotesCount\n        storiesCount\n        projectsCount\n        savedStoriesCount\n        savedProductsCount\n        savedProjectsCount\n        savedPostsCount\n        savedCount\n        avatar\n        jobTitle\n        isFollowing\n        isDisruptor\n        showDeleteUserWarning\n        isSelfie\n        isSiteAdmin\n        searchable\n        preferences {\n          showAsAuthorOnProjects\n        }\n        newsletterFrequency\n        subscribedToNewsletter\n        subscribedToCampaign\n        socialMedia {\n          youtube\n          twitter\n          instagram\n          linkedin\n          facebook\n        }\n        linkedinUrl\n        company {\n          _id\n          name\n          slug\n          logo\n          members {\n            _id\n            slug\n            avatar\n            firstName\n            fullName\n            jobTitle\n          }\n        }\n        cover {\n          original\n          repositioned\n        }\n        following {\n          ...FollowingFields\n        }\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n        country\n        language\n        timeZone\n      }\n    }\n  }\n"
    ]);
    ProfileQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var ProfileQuery = ((0,lib/* gql */.Ps)(ProfileQuery_templateObject(), GroupFields/* default */.Z, FollowingFields));


/***/ }),

/***/ 26346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment GovernmentPostFields on GovernmentPost {\n    _id\n    body\n    audience\n    upvotesCount\n    commentsCount\n    viewerDidBookmark\n    viewerDidUpvote\n    viewerDidComment\n    viewerCanEdit\n    viewerCanDelete\n    viewerCanComment\n    createdAt\n    featuredAt\n    viewerIsAuthor\n    created: createdAt\n    author {\n      ... on GovernmentUser {\n        _id\n        slug\n        email\n        fullName\n        firstName\n        avatar\n        jobTitle\n        government {\n          _id\n          name\n          logo\n          slug\n          city {\n            _id\n            country\n            countryName\n          }\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        email\n        fullName\n        firstName\n        avatar\n        jobTitle\n        company {\n          _id\n          name\n          logo\n          slug\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        fullName\n        firstName\n        email\n        avatar\n        jobTitle\n      }\n    }\n    attachments {\n      mimeType\n      filename\n      sizeInBytes\n      url\n    }\n    links {\n      addedAt\n      description\n      title\n      favicon\n      siteName\n      url\n    }\n    government {\n      _id\n      slug\n      name\n      logo\n      city {\n        _id\n        country\n        countryName\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 89471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment GroupFields on Group {\n    _id\n    slug\n    logo\n    name\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 90910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment GroupPostFields on GroupPost {\n    _id\n    body\n    audience\n    upvotesCount\n    commentsCount\n    viewerDidBookmark\n    viewerDidUpvote\n    viewerDidComment\n    viewerCanEdit\n    viewerCanDelete\n    viewerCanComment\n    createdAt\n    featuredAt\n    viewerIsAuthor\n    created: createdAt\n    author {\n      ... on GovernmentUser {\n        _id\n        slug\n        fullName\n        firstName\n        avatar\n        email\n        jobTitle\n        government {\n          _id\n          name\n          logo\n          slug\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        fullName\n        email\n        firstName\n        avatar\n        jobTitle\n        company {\n          _id\n          name\n          logo\n          slug\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        email\n        fullName\n        firstName\n        avatar\n        jobTitle\n      }\n    }\n    attachments {\n      mimeType\n      filename\n      sizeInBytes\n      url\n    }\n    links {\n      addedAt\n      description\n      title\n      favicon\n      siteName\n      url\n    }\n    group {\n      _id\n      name\n      slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 50472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VendorPostFields on VendorPost {\n    _id\n    body\n    audience\n    upvotesCount\n    commentsCount\n    viewerDidBookmark\n    viewerDidUpvote\n    viewerDidComment\n    viewerCanEdit\n    viewerCanDelete\n    viewerCanComment\n    createdAt\n    featuredAt\n    viewerIsAuthor\n    created: createdAt\n    author {\n      ... on GovernmentUser {\n        _id\n        slug\n        email\n        fullName\n        firstName\n        avatar\n        jobTitle\n        government {\n          _id\n          name\n          logo\n          slug\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        email\n        fullName\n        firstName\n        avatar\n        jobTitle\n        company {\n          _id\n          name\n          logo\n          slug\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        fullName\n        firstName\n        email\n        avatar\n        jobTitle\n      }\n    }\n    attachments {\n      mimeType\n      filename\n      sizeInBytes\n      url\n    }\n    links {\n      addedAt\n      description\n      title\n      favicon\n      siteName\n      url\n    }\n    vendor {\n      _id\n      slug\n      name\n      logo\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ })

}]);